import { createSelector } from 'reselect';
import explorerSelector from './explorer';

import { defaultState } from '../reducer';

export default createSelector(
  explorerSelector,
  explorer =>
    explorer.showCreateMasterComponentDialog || defaultState.showCreateMasterComponentDialog
);
